<template>
    <div>
        <CollapseConfirmData
            :code-id="code"
            @removeService="removeService"
        >
            <template #content>
                <ul class="text-tip">
                    <li>
                        本次申請變更內容，將同時更新以您為要保人於本公司所投保之所有個人險有效及停效保單。
                    </li>
                </ul>

                <div
                    v-for="(item, index) in afterData"
                    :key="index"
                >
                    <ResultList :title="item.title">
                        <li v-if="item.addr && item.addr!==''">
                            {{ item.addr }}
                        </li>
                        <li v-if="item.phone&&item.phone!==''">
                            <span v-if="item.telAreaCode">
                                {{ `${item.telAreaCode}-` }}
                            </span>
                            <span>
                                {{ item.tel }}
                            </span>
                            <span v-if="item.telExt">
                                分機 {{ item.telExt }}
                            </span>
                        </li>
                        <li v-if="item.mobile&&item.mobile!==''">
                            <span v-if="item.mobileCountry!=='886'">
                                (+{{ item.mobileCountry }})
                            </span>
                            {{ item.mobile }}
                        </li>
                        <li v-if="item.email&&item.email!==''">
                            <p>{{ item.email }}</p>
                        </li>
                    </ResultList>
                </div>

                <h4 class="mb-2 mt-4 md:mt-5">
                    轉送保全聯盟鏈
                </h4>
                <p>
                    <span v-if="allianceChain">同意授權本公司將變更資料，傳送至以下保險公司申辦相同項目變更</span>
                    <span v-else>不同意授權本公司將變更資料，傳送至其他保險公司申辦相同項目變更</span>
                </p>
                <div v-if="allianceChain?.life">
                    <h5 class="mt-4 mb-2 md:mt-5">
                        壽險公司
                    </h5>
                    <p>
                        {{ allianceChain.life }}
                    </p>
                </div>
                <div v-if="allianceChain?.property">
                    <h5 class="mt-4 mb-2 md:mt-5">
                        產險公司
                    </h5>
                    <p>
                        {{ allianceChain.property }}
                    </p>
                </div>
            </template>
        </CollapseConfirmData>
    </div>
</template>
<script>
import { toRef, computed, ref } from 'vue';

import CollapseConfirmData from '@/components/collapse/CollapseConfirmData.vue';
import ResultList from '@/components/template/ResultList.vue';

export default {
    name: 'BDData',
    components: {
        CollapseConfirmData,
        ResultList
    },
    props: {
        result: {
            type: Object,
            required: true,
        }
    },
    emits: ['removeService'],
    setup(props, { emit }) {
        const code = ref('BD');
        // 被保人區塊資訊 insuredInfo // 收費區塊資訊 chargeInfo
        // 要保人區塊資訊 applicantInfo // 要保人行動電話 mobile // 要保人Email email
        const data = toRef(props, 'result');
        const blockNameList = {
            insuredInfo: '被保險人住所/電話/E-mail',
            chargeInfo: '收費地址/電話',
            applicantInfo: '要保人住所(戶籍地址)/電話',
            mobile: '要保人行動電話',
            email: '要保人E-mail',
        };
        const after = computed(() => {
            const ary = data.value.after;
            ary.mobileCountry = ary.mobileCountry === '' ? '886' : ary.mobileCountry;

            if (ary.insuredInfo) {
                ary.insuredInfo.mobileCountry = ary.insuredInfo.mobileCountry === '' ? '886' : ary.insuredInfo.mobileCountry;
            }
            return ary;
        });
        const makeBDData = (data) => {
            const newary = [];
            const keys = Object.keys(blockNameList);
            keys.forEach(key => {
                let i = {};
                const val = data[key];
                if (val) {
                    if (key === 'mobile') {
                        i = {
                            [key]: val,
                            mobileCountry: data.mobileCountry,
                        };
                    } else if (key === 'email') {
                        i = { [key]: val };
                    } else {
                        i = {
                            ...val,
                            addr: val.city + val.cityArea + val.address,
                            phone: val.telAreaCode + val.tel + val.telExt,
                        };
                    }
                    const change = Object.values(i).join('');
                    if (change.trim() !== '') {
                        i = { ...i, id: key, title: blockNameList[key] };
                        newary.push(i);
                    }
                }
            });
            return newary;
        };
        const afterData = ref(makeBDData(after.value));

        const allianceChain = ref(data.value.allianceChainResult);
        const removeService = () => {
            emit('removeService', code.value);
        };

        return {
            removeService,
            code,
            after,
            allianceChain,
            blockNameList,
            afterData,
        };
    },
};
</script>
